import hero from "../images/home_hero.png";
import sc_logo from "../images/logo_home_mobile.png";
import logo1 from "../images/maternityMates_Logo.png";
import logo2 from "../images/herHealth_Logo.png";
import logo3 from "../images/healingConversation_Logo.png";
// import logo4 from "../images/peerSupportGroup_Logo.png";

import Navbar from "../sections/Navbar.js";
import Footer from "../sections/Footer.js";
import { useRef, useState, useCallback } from "react";

const Home = () => {
  const logo_css = "xl:h-[110px] lg:h-24 md:h-20 sm:h-25 s:h-24 xs:h-20 w-auto md:mb-0   object-contain";

  const logoSectionRef = useRef();

  // Track whether the navbar overlay (dropdown/mobile menu) is active
  // When active, the sc_logo z-index drops so it doesn't sit above the nav
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  return (
    <div className=" bg-[#b24029]  h-screen">
      <Navbar whichRef={logoSectionRef} onOverlayActive={handleOverlayActive} />
      {/* ---------------------------------------------------------------------------------------------------------------
    ---------------------------------------OPENING HOME content--------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#DCB1FA] ">
        <div className="mx-auto max-w-[1440px]">
          <div className="flex xs:flex-col md:flex-row md:w-full xs:w-4/5 xs:mx-auto w-full bg-[#DCB1FA] overflow-hidden">
            {/* 
              CLAMP() RESPONSIVE TYPOGRAPHY
              =============================
              Uses mathematical clamp() formula: clamp(10px, -0.408rem + 0.122449vw, 16px)
              • Above 1340px: Fixed 16px
              • 1340px→850px: Fluid scaling 16px→10px  
              • Below 850px: Fixed 10px
              • Spans scale proportionally with em units
            */}
            <div className="flex flex-wrap items-center md:w-2/4 xs:mt-32 md:mt-0 responsive-base-font">
              <a href="/" className="">
                <img
                  src={sc_logo}
                  className={`xs:mt-6 md:ml-6 responsive-home-logo-width sm:w-[182px] s:w-[160px] xs:w-[130px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
                  alt="secret-circle-logo"
                />
              </a>

              <p className="  xs:mt-9 md:mt-0 xs:mr-0 xs:ml-0 md:ml-[4.5rem] md:mr-10   font-sans font-normal antialiased align-middle text-[#b24029] ">
                <span className="xs:text-[2.3em] md:leading-[1.1em] xs:leading-[1.2em]">
                  We are a charity putting women's health first.
                </span>
                <br />
                <br />
                <br />
                <span className="  xs:text-[1.55em] xs:leading-[1.2em] ">
                 We support women in challenging circumstances to empower themselves and lead healthy lives through service provision, advocacy and peer support.<br /><br />If you or someone you know needs support, we have several programs to meet your needs.
                </span>
                <br />

                <a
                  href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="min-[950px]:mt-10 min-[900px]:mt-8  md:mt-6 xs:mt-10    md:mb-0 xs:mb-14 xs:text-[1.3em]  w-fit xs:leading-[1.55em] px-6 py-2 inter-button font-medium antialiased  border-2 border-[#b24029] rounded-[3em]">
                    Get support now
                  </button>
                </a>
              </p>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}

            <div className="md:w-2/4  flex flex-wrap items-end md:mt-0   ">
              <img src={hero} className=" mx-auto   " alt="hero" />
            </div>
          </div>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Logo Section --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={logoSectionRef} className="bg-[#F7E1DA] ">
        <div className="mx-auto max-w-[1440px] ">
          <div className="  min-h-[272px] md:flex xs:grid  md:grid-cols-4 min-[600px]:grid-cols-2 xs:w-4/5 md:w-full items-center xs:mx-auto md:mx-0 md:gap-0 xs:gap-16 md:justify-between lgx:py-24 md:py-16 xs:py-16 lgx:px-[7%] md:px-[5%] ">
            <a href="/get-support/#Maternity-Mates">
              <img src={logo1} alt="Maternity Mates" className={logo_css} />
            </a>
            <a href="/get-support/#Her-Health">
              <img src={logo2} alt="Her Health " className={logo_css} />
            </a>
            <a href="/get-support/#Healing-Conversations">
              <img src={logo3} alt="Healing Conversations" className={logo_css} />
            </a>
            {/* <img src={logo4} alt="Peer Support Group" className={logo_css} /> */}
          </div>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Section End --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <Footer />
    </div>
  );
};

export default Home;
